import { pushPaginaAtiva, clearPaginas } from './../../../shared/activePage';
import { formatarCNPJ } from './../../../shared/formatter';
import {
  Component,
  OnInit,
  ViewChild,
  AfterViewInit,
  ViewEncapsulation,
  signal,
} from '@angular/core';
import { Router } from '@angular/router';
import axiosClient from '../../../../shared/axios/axios-client';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import {
  MatPaginator,
  MatPaginatorIntl,
  MatPaginatorModule,
  PageEvent,
} from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import estados from '../../../../assets/json/estados.json';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { getPaginatorIntl } from '../../../shared/mat-paginator-intl';
import { AuthService } from '../../../services/auth/auth.service';

interface Empresa {
  id: number;
  nomeFantasia: string;
  razaoSocial: string;
  cnpj: string;
  estado: string;
  cidade: string;
}

@Component({
  selector: 'app-listar-empresas',
  templateUrl: './listar-empresas.html',
  styleUrls: ['./listar-empresas.scss'],
  imports: [
    CommonModule,
    FormsModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
  ],
  providers: [
    {
      provide: MatPaginatorIntl,
      useFactory: getPaginatorIntl,
    },
  ],
  encapsulation: ViewEncapsulation.None,
})
export class ListarEmpresas implements OnInit, AfterViewInit {
  displayedColumns: string[] = ['nomeFantasia', 'cnpj', 'estado', 'cidade'];
  dataSource = new MatTableDataSource<Empresa>([]);

  // Configurações de paginação
  pageSize = 10;
  pageSizeOptions = [5, 10, 25];
  total = 0;
  inicio = 1;
  fim = 10;
  textoContagem = 'Mostrando 0 a 0 de 0 resultados';

  filtroNome = '';
  filtroEstado = '';
  estados: string[] = [];

  podeCriarEmpresa = signal(false);

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(
    private router: Router,
    private readonly authService: AuthService
  ) {}

  formatarCnpjLocal = (cnpj: string) => formatarCNPJ(cnpj);
  async ngOnInit(): Promise<void> {
    clearPaginas();
    pushPaginaAtiva({
        nome: 'Home',
        rota: '/home'
    });
    pushPaginaAtiva({
        nome: 'Empresas cadastradas',
        rota: ''
    });

    this.podeCriarEmpresa.set(this.authService.isMaster());
    try {
      const res = await axiosClient.get('/empresa');
      this.dataSource.data = res.data;
      this.total = this.dataSource.data.length;
      this.atualizarContagem(0, this.pageSize);

      this.estados = estados.map((estado: any) => estado.nome);

      this.dataSource.filterPredicate = (data: Empresa, filter: string) => {
        const filtros = JSON.parse(filter);

        const nomeOuCnpjMatch =
          data.nomeFantasia
            .toLowerCase()
            .includes(filtros.nome.toLowerCase()) ||
          data.cnpj.toLowerCase().includes(filtros.nome.toLowerCase());

        const estadoMatch = filtros.estado
          ? data.estado === filtros.estado
          : true;

        return nomeOuCnpjMatch && estadoMatch;
      };
    } catch (err) {
      console.error(err);
      this.total = 0;
      this.atualizarContagem(0, this.pageSize);
    }
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.sort.active = 'nomeFantasia';
    this.sort.direction = 'asc';
    this.dataSource.sort = this.sort;
  }

  onPageChange(event: PageEvent) {
    this.pageSize = event.pageSize;
    this.atualizarContagem(
      event.pageIndex,
      event.pageSize,
      this.dataSource.filteredData.length
    );
  }

  atualizarContagem(pageIndex: number, pageSize: number, totalRows?: number) {
    const totalExibicao = totalRows ?? this.dataSource.data.length;
    const maxPageIndex = Math.max(0, Math.ceil(totalExibicao / pageSize) - 1);
    pageIndex = Math.min(pageIndex, maxPageIndex);

    const startItem = pageIndex * pageSize + 1;
    const endItem = Math.min((pageIndex + 1) * pageSize, totalExibicao);

    this.inicio = totalExibicao > 0 ? startItem : 0;
    this.fim = endItem;

    // Formatação do texto com pluralização correta
    if (totalExibicao === 0) {
      this.textoContagem = 'Nenhum resultado encontrado';
    } else if (totalExibicao === 1) {
      this.textoContagem = 'Mostrando 1 resultado';
    } else {
      this.textoContagem = `Mostrando ${this.inicio} a ${this.fim} de ${totalExibicao} resultados`;
    }
  }

  aplicarFiltro() {
    const filtro = {
      nome: this.filtroNome.trim(),
      estado: this.filtroEstado,
    };
    this.dataSource.filter = JSON.stringify(filtro);

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }

    this.atualizarContagem(
      0,
      this.pageSize,
      this.dataSource.filteredData.length
    );
  }

  adicionarEmpresa() {
    this.router.navigate(['/empresas/cadastrar']);
  }

  abrirDetalhesEmpresa(id: number) {
    this.router.navigate(['/empresas/', id]);
  }
}
